/* Candidate storefront bridge. Disabled until Whop's collection and revoke
 * contract is verified and the expanded privacy scope is approved. */
(function () {
  "use strict";

  var config = window.AudienWhopFullInstall || {};
  if (config.enabled !== true) return;

  var accountId = config.accountId;
  var source = "https://t.whop.tw/s.js";
  var excluded = ["quiz", "hearing-test", "hearing-assessment", "order-tracking"];
  var emailPattern = /[^\s@\/?&=#:]+@[^\s@\/?&=#:]+\.[a-z]{2,}/i;
  var loaded = false;
  var loading = false;
  var lastTrackedUrl = null;
  var privacyReady = false;

  function isExcluded(rawUrl) {
    if (!rawUrl) return true;
    try {
      var path = new URL(rawUrl, window.location.origin).pathname.toLowerCase();
      return excluded.some(function (term) { return path.indexOf(term) !== -1; });
    } catch (_) {
      return true;
    }
  }

  // Safety net: an email anywhere in the URL (plain or percent-encoded) means
  // we do not track, whatever the page.
  function containsEmail(rawUrl) {
    if (!rawUrl) return false;
    var value = String(rawUrl);
    for (var i = 0; i < 3; i++) {
      if (emailPattern.test(value)) return true;
      try {
        var decoded = decodeURIComponent(value.replace(/\+/g, " "));
        if (decoded === value) break;
        value = decoded;
      } catch (_) {
        return /%40/i.test(String(rawUrl));
      }
    }
    return false;
  }

  function eligible() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacyReady || !privacy) return false;
    if (isExcluded(window.location.href)) return false;
    if (containsEmail(window.location.href)) return false;
    // A prior quiz/test URL might otherwise be read by opaque vendor code.
    if (document.referrer && isExcluded(document.referrer)) return false;
    if (containsEmail(document.referrer)) return false;
    try {
      return privacy.marketingAllowed() === true &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.saleOfDataAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function clearWhopStorage() {
    ["_wuid", "_wuid_link"].forEach(function (name) {
      document.cookie = name + "=; Max-Age=0; Path=/; SameSite=Lax";
      document.cookie = name + "=; Max-Age=0; Path=/; Domain=audienhearing.com; SameSite=Lax";
    });
    ["_wuid", "_wfp", "_wsc", "_wuid_link_domain", "_wuid_link_seen"].forEach(function (name) {
      try { window.localStorage.removeItem(name); } catch (_) { /* blocked storage */ }
    });
  }

  function trackPage() {
    if (!loaded || !eligible() || lastTrackedUrl === window.location.href) return;
    // Storefront page views are owned by s.js. The pixel sends page_viewed
    // only on checkout and order status, where theme scripts do not run.
    try {
      window.whop.track("page");
      lastTrackedUrl = window.location.href;
    } catch (_) { /* vendor script error */ }
  }

  function installStub() {
    if (window.whop) return false;
    var whop = window.whop = {
      q: [],
      t: +new Date(),
      s: [],
      o: "https://t.whop.tw",
      track: function () {
        whop.q.push([+new Date()].concat([].slice.call(arguments)));
      },
      setScope: function () {
        whop.s = [].slice.call(arguments).filter(function (item) {
          return typeof item === "string";
        });
        whop.q.push([+new Date(), "setScope"].concat(whop.s));
      }
    };
    // Derrick's suggested collection limits do not disable FingerprintJS.
    whop.c = {
      forms: false,
      urlIdentity: false,
      links: false,
      iframes: false,
      sc: false
    };
    whop.setScope(accountId);
    return true;
  }

  function reconcile() {
    if (!eligible()) {
      clearWhopStorage();
      lastTrackedUrl = null;
      // s.js has no stop() call. Whop's supported revoke flow is to clear the
      // identifiers and reload; after the reload the gate is closed, so s.js
      // never loads again for this visitor.
      if (loaded || loading) window.location.reload();
      return;
    }
    if (loaded) {
      trackPage();
      return;
    }
    if (loading || !accountId) return;
    loading = true;
    if (!installStub()) {
      loading = false;
      return;
    }
    var script = document.createElement("script");
    script.async = true;
    script.src = source;
    script.onload = function () {
      loading = false;
      loaded = true;
      trackPage();
    };
    script.onerror = function () {
      loading = false;
    };
    document.head.appendChild(script);
  }

  function routeChanged() {
    setTimeout(reconcile, 0);
  }

  function wrapHistory(name) {
    var original = history[name];
    history[name] = function () {
      var result = original.apply(this, arguments);
      routeChanged();
      return result;
    };
  }

  wrapHistory("pushState");
  wrapHistory("replaceState");
  window.addEventListener("popstate", routeChanged);
  window.addEventListener("pageshow", routeChanged);
  document.addEventListener("visitorConsentCollected", reconcile);

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;
  window.Shopify.loadFeatures(
    [{ name: "consent-tracking-api", version: "0.1" }],
    function (error) {
      if (error) return;
      privacyReady = true;
      reconcile();
    }
  );
})();
